module.exports = __webpack_public_path__ + "img/3-1.aac19d90.png";